import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import Datetime from 'react-datetime'
import moment from 'moment'

import { dateFormat, dateFormatMonths } from '../../helpers/helpers'
import * as user from 'commons'
import { getDateRange } from '../../reducers/dateRange'
import { updateStartDate } from '../../actions/dateRange'

const DateRangeStartDateGlobal = ({ dispatch, dateRange, location, lng }) => (
  <Datetime
    id="startDate"
    locale={lng}
    closeOnSelect
    timeFormat={false}
    dateFormat={location.pathname === '/market-informations' ? dateFormat() : dateFormatMonths()}
    viewMode={location.pathname === '/market-informations' ? 'days' : 'months'}
    value={moment(dateRange.startDate).toDate()}
    onChange={(date) => {
      if (!moment.isMoment(date)) return
      dispatch(updateStartDate(date))
    }}
  />
)

const mapStateToProps = (state) => ({
  dateRange: getDateRange(state),
  lng: user.lngIso(state),
})

DateRangeStartDateGlobal.propTypes = {
  dispatch: PropTypes.func.isRequired,
  dateRange: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  lng: PropTypes.string.isRequired,
}

export default withRouter(connect(mapStateToProps)(DateRangeStartDateGlobal))
